import React from "react";
import { motion } from "framer-motion";
import "../../asstes/styles/privateCouncilTeam.scss";
import animationImage1 from "../../asstes/images/private-council/animationImage1.jpg";
import animationImage2 from "../../asstes/images/private-council/animationImage2.jpg";
import animationImage3 from "../../asstes/images/private-council/animationImage3.jpg";
import animationImage4 from "../../asstes/images/private-council/animationImage4.jpg";

const container = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: 0.3, // delay between each child
        },
    },
};

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const PrivateCouncilTheMomentArrive = () => {
    return (
        <section className="private-council-moment-section">
            <div className="container private-council-moment-p-120-30">
                <div className="row justify-content-between align-items-center">

                    <motion.div
                        variants={container}
                        initial="hidden"
                        animate="show"
                        className="col-lg-6 col-xl-6 col-12"
                    >
                        <motion.h2
                            variants={fadeUp}
                            className="private-council-moment-mb-60"
                        >
                            When the Moment<br /> Arrives
                        </motion.h2>

                        <motion.ul
                            className="private-council-moment-text list-style-point"
                        >
                            <motion.li variants={fadeUp}>
                                This is the moment where hesitation ends and consequence begins.
                            </motion.li>

                            <motion.li variants={fadeUp}>
                                When the decision cannot wait, clarity must arrive.
                            </motion.li>

                            <motion.li variants={fadeUp}>
                                Not guidance. Not reassurance. A reckoning.
                            </motion.li>
                        </motion.ul>
                    </motion.div>


                    <div className="col-lg-6 col-xl-6 col-12">
                        <div className="private-council-moment-team-list">
                            <div className="private-council-moment-lines-place mil-lines-place">
                               <svg width="250" viewBox="0 0 300 1404" fill="none" xmlns="http://www.w3.org/2000/svg" class="mil-lines ">
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M1 892L1 941H299V892C299 809.71 232.29 743 150 743C67.7096 743 1 809.71 1 892ZM0 942H300V892C300 809.157 232.843 742 150 742C67.1573 742 0 809.157 0 892L0 942Z" class="mil-move"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M299 146V97L1 97V146C1 228.29 67.7096 295 150 295C232.29 295 299 228.29 299 146ZM300 96L0 96V146C0 228.843 67.1573 296 150 296C232.843 296 300 228.843 300 146V96Z" class="mil-move"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M299 1H1V1403H299V1ZM0 0V1404H300V0H0Z"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M150 -4.37115e-08L150 1404L149 1404L149 0L150 -4.37115e-08Z"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M150 1324C232.29 1324 299 1257.29 299 1175C299 1092.71 232.29 1026 150 1026C67.7096 1026 1 1092.71 1 1175C1 1257.29 67.7096 1324 150 1324ZM150 1325C232.843 1325 300 1257.84 300 1175C300 1092.16 232.843 1025 150 1025C67.1573 1025 0 1092.16 0 1175C0 1257.84 67.1573 1325 150 1325Z" class="mil-move"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M300 1175H0V1174H300V1175Z" class="mil-move"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M150 678C232.29 678 299 611.29 299 529C299 446.71 232.29 380 150 380C67.7096 380 1 446.71 1 529C1 611.29 67.7096 678 150 678ZM150 679C232.843 679 300 611.843 300 529C300 446.157 232.843 379 150 379C67.1573 379 0 446.157 0 529C0 611.843 67.1573 679 150 679Z" class="mil-move"></path>
                               <path fill-rule="evenodd" clip-rule="evenodd" d="M299 380H1V678H299V380ZM0 379V679H300V379H0Z" class="mil-move"></path>
                               </svg>
                            </div>
                            <div className="row private-council-moment-mb-60">

                                <div className="col-sm-6">
                                    <TeamCard img={animationImage1} name="Optimization" role="Strategy" />
                                    <TeamCard img={animationImage2} name="Personal Growth" role="Development" />
                                </div>

                                <div className="col-sm-6">

                                    <motion.p
                                        className="private-council-moment-text-sm private-council-moment-mb-30"
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                    >
                                        {/* <span className="private-council-moment-accent">*</span> Core transformation areas */}
                                    </motion.p>

                                    <TeamCard img={animationImage3} name="Performance" role="Enhancement" />
                                    <TeamCard img={animationImage4} name="Guidance" role="Clarity" />

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

const TeamCard = ({ img, name, role }) => {
    return (
        <motion.div
            className="private-council-moment-team-card"
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            whileHover={{ scale: 1.04 }}
        >
            <motion.img
                src={img}
                alt={name}
                initial={{ scale: 1.1 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            />

            {/* overlay animation ONLY with framer */}
            <motion.div
                className="private-council-moment-overlay"
                whileHover={{ y: 0 }}
                initial={{ y: "100%" }}
                transition={{ duration: 0.4 }}
            >
                <h5>{name}</h5>
                <p>{role}</p>
            </motion.div>
        </motion.div>
    );
};

export default PrivateCouncilTheMomentArrive;